module.exports = __webpack_public_path__ + "img/cachepayment.7499aca9.svg";